import { Get, Put } from "../utils/http-utils";

export const getAssetsForRegistration = async () => {
    const queryParams = { status: 'NEW' };

    return Get("/product", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });

};


export const approveAsset = async (jsonPayload) => {

    return Put("/product", jsonPayload)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw new Error(`Asset Approve Request Failed with:`, err);
        });

};

export const rejectAsset = async (jsonPayload) => {
    return Put("/product", jsonPayload)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw new Error(`Asset Reject Request Failed with:`, err);
        });
};